import { CheckoutAccountFormStatus, CheckoutMixpanelEvent } from 'types/checkout';
import { investmentEntity } from '@store/modules/investment-entity';
import { InvestmentEntityType } from 'types/investment-entity';
import { orderForm } from '@store/modules/order-form';
import { RawLocation } from 'vue-router';
import { trackMixpanel } from './analytics';

export const buildCheckoutMixpanelProperties = (): CheckoutMixpanelEvent => {
	const properties: CheckoutMixpanelEvent = {
		'Order Type': 'RIA',
		'RIA Plan': orderForm.plan?.name || ''
	};

	if (orderForm.orderGroupId) {
		properties['Investment Amount'] = orderForm.investmentAmount;
		properties['Entity Type'] = investmentEntity.entityTypeLabel;
		properties['Transaction Type'] = 'ACH';
		properties['Investments'] = orderForm.investments;
		if (orderForm.paymentMethodSetup) {
			properties['Payment Method Setup'] = orderForm.paymentMethodSetup;
		}
		if (orderForm.paymentMethodCreationMethod) {
			properties['Payment Method Creation Method'] = orderForm.paymentMethodCreationMethod;
		}
	}

	return properties;
};

export const sendCheckoutMixpanel = (eventName: string): void => {
	const properties: CheckoutMixpanelEvent = buildCheckoutMixpanelProperties();

	trackMixpanel(eventName, properties);
};

export const accountDetailsRoute = (
	entityType: InvestmentEntityType,
	userRoute: CheckoutAccountFormStatus
): RawLocation => {
	switch (entityType) {
		case 'INDIVIDUAL':
			return { name: 'checkout-individual-account-details' };
		case 'JOINT_ACCOUNT':
			return { name: 'checkout-joint-account-details', query: { account: userRoute } };
		case 'LLC':
			return {
				name: 'checkout-entity-account-details',
				query: { account: userRoute }
			};
		case 'TRUST':
			return { name: 'checkout-trust-account-details', query: { account: userRoute } };
		default:
			return { name: '404' };
	}
};
